<template>
  <div class="content">
    <loading v-if="loading" text='Loading. Please wait...'/>
    <div v-if="!loading">
      <div class="table">
        <div class="tr">
          <div class="td-title">
            <h1 v-if="resource.category !== 'flashcarddeck'">{{resource.title}}</h1>
          </div>
          <div v-if="resource.category === 'flashcarddeck' && resource.private && showFlascardTools" class="flashcard-tools">
            <div v-if="editCurrentFlashcardDeck" @click="editFlashcardDeck();" class="icon-button no-select">
              <i class="fal fa-edit"></i>
            </div>
            <Popover ref="removeFlashcardDeck" placement="bottom" :width="270">
              <div @click=";" class="icon-button">
                <i class="fal fa-trash-alt"></i>
              </div>
              <div slot="content">
                <div class="delete-message">Permanently delete this deck?</div>
                <div class="popover-buttons">
                  <button v-on:click.stop="closeDeletePopover();" class="button is-primary">No</button>
                  <button v-on:click.stop="deleteFlashcardDeck();" class="button is-pulled-right">Yes</button>
                </div>
              </div>
            </Popover>
          </div>
          <div v-on:click="closeResource()" class="icon-button close-text">
            <i class="fal fa-times" aria-hidden="true"></i>
          </div>
        </div>
      </div>
   
      <span v-show="error" class="help is-danger">{{error}}</span>

      <div v-if="resource.category === 'image'">
        <img width="100%" :src="resource.absoluteUrl" />
      </div>
      <div v-else-if="resource.category === 'text'">
        {{resource.text}}
      </div>
      <div v-else-if="resource.category === 'video'">
        <video width="100%" controls>
          <source :src="resource.absoluteUrl" type="video/mp4">
          Your browser does not support videos.
        </video>
      </div>
      <div v-else-if="resource.category === 'audio'">
        <audio width="100%" controls>
          <source :src="resource.absoluteUrl" type="audio/mpeg">
          Your browser does not support audio clips.
        </audio>
      </div>
      <div v-else-if="resource.category === 'assessment'">
        <AssessmentPlayer
          v-bind="{wantToClose}"
          :resource="resource"
          :attachment="attachment"
          @canBeClosed="val => canBeClosed = val"
        />
      </div>
      <div v-else-if="resource.category === 'flashcarddeck'">
        <iframe id="flashcarddeckIframe" :src="$config.get('basePathFiles') + 'static/libs/flashcards/index.html'" v-on:load="onFlashcarddeckIframeLoad()">
        </iframe>
      </div>

      <div v-if="assesmentWarning" class="modal no-select">
        <div class="modal-content">
          <h2>Submit incomplete assessment?</h2>
          <p class="has-text-left">Are you sure you want to submit your assessment, even though you have NOT finished it? This action cannot be reversed.</p>
          <div class="modal-buttons is-pulled-right">
            <button v-on:click.stop="wantToClose = false; assesmentWarning = false" class="button is-primary">Cancel</button>
            <button v-on:click.stop="submitAssessment()" class="button">Submit</button>
          </div>
        </div>
      </div>
      <!-- <div v-else-if="resource.category === 'pdf'">
        <iframe :src='resource.absoluteUrl' width='1366' height='623' frameborder='0'>
         This is an embedded PDF document
        </iframe>
      </div>
      <div v-else-if="resource.category === 'word' || resource.category === 'powerpoint' || resource.category === 'excel'">
        <iframe :src='"https://view.officeapps.live.com/op/embed.aspx?src=" + resource.absoluteUrl' width='1366' height='623' frameborder='0'>
          This is an embedded <a target='_blank' href='http://office.com'>Microsoft Office</a> document, powered by <a target='_blank' href='http://office.com/webapps'>Office Online</a>.
        </iframe>
      </div> -->
    </div>
  </div>
</template>

<script>
  const _ = require('lodash');
  
  import Vue from 'vue'
  import utils from '@/utils/utils.js';
  import storeHelpers from '@/utils/storeHelpers.js';
  import AssessmentPlayer from '../assessments/AssessmentPlayer';
  import Popover from '@/components/widgets/popover';
  import serverUtils from '@/utils/serverUtils.js';
  import analytics from '@/utils/analytics.js';

  var aesjs = require('aes-js');
  
  export default {
    name: 'ResourceView',
    components: {
      AssessmentPlayer,
      Popover
    },
    data: function () {
      var t = this;

      return {
       loading: true,
       utils: utils,
       error: '',
       resource: undefined,
       attachment: undefined,
       unwatchFunction: undefined,
       canBeClosed: true,
       wantToClose: false,
       assesmentWarning: false,
       editCurrentFlashcardDeck: true,
       showFlascardTools: true,
       queryParams: {}
      }
    },
    destroyed: function() {
      window.onbeforeunload = function () {}
      window.onpopstate = function() {}
      this.unwatchFunction();
    },
    mounted: function () {
      this.unwatchFunction = utils.watchStoreProperty(this, 'resources', this.resourcesUpdated);
    },
    watch: {
      canBeClosed(val) {
        if (!val) {
          var t = this;
          window.onbeforeunload = function() {
            t.wantToClose = true;
            return true;
          }
        }
      }
    },
    methods: {
      resourcesUpdated: function() {
        // first load only 
        if(!this.resource) {
          if (!this.$route.query.res)
            return;
          this.resource = storeHelpers.getResourceById(this, this.$route.query.res);
          if (this.$route.query.att)
            this.attachment = storeHelpers.getAttachmentById(this, this.$route.query.att);

          // if locked is not a property of the attachment, add it
          if (this.attachment && this.attachment.locked === undefined) {
            // console.log("Checking attachment", this.attachment, "for locked resources")
            this.attachment = utils.filterLockedResources(this, [this.attachment])[0]
          }

          // console.log(this.attachment)
          // console.log(this.attachment && this.attachment.visible == false)
          // console.log(this.attachment && this.attachment.locked)
          // console.log((this.attachment && this.attachment.visible == false) || (this.attachment && this.attachment.locked))
          if ((this.attachment && this.attachment.visible == false) || (this.attachment && this.attachment.locked)) {
            this.error = "Resource is either hidden or locked.";
            this.loading = false;
            return;
          }

          // My folders
          if(this.resource && !this.resource.category) {
            this.resource.category = this.resource.type;
          }

          if(this.resource && !this.resource._id) {
            this.resource._id = this.resource.id;
          }

          if (this.resource && this.resource.category !== "assessment" || !storeHelpers.isSpecificAssessment(this.attachment))
            storeHelpers.markAsRead(this, this.resource, this.attachment);

          if(this.resource && this.resource.category === "image" || this.resource.category === "text" || this.resource.category === "video" || this.resource.category === "audio" || this.resource.category === "assessment" || this.resource.category === "flashcarddeck") {
            this.resource.absoluteUrl = this.$config.get('ecApi') + 'resources/' + this.resource._id + '/data?auth_token=' + this.$store.state.user.cookieToken;
          } else {
            var absoluteURL = this.$config.get('ecApi') + 'resources/' + this.resource._id + '/data?auth_token=' + this.$store.state.user.cookieToken;
            utils.downloadFile(absoluteURL, this.resource._id);
            this.closeResource();
          }

          this.queryParams = this.$route.query;
          var location = 0;

          utils.log(this, "From: ", this.queryParams)
          if (this.queryParams.f === "fe") {
            this.editCurrentFlashcardDeck = false;
            // function(handle, attachmentId, attachmentPrivate, attachmentCategory, from = 0)
            if (this.attachment)
              analytics.attachmentOpen(this, this.attachment._id, this.attachment.private, this.attachment.resourceType, 1);
            else
              analytics.resourceOpen(this, this.resource, 0, false);
          } else {
            var location = parseInt(this.queryParams.f, 10);
            if (this.queryParams.f === "br") {
              this.showFlascardTools = false;
              location = 1;
            }
            var externally = this.resource && this.resource.category === "url" ? true : false;
            analytics.resourceOpen(this, this.resource, location, externally);
          }
          this.loading = false;
        }
      },
      postFlashCardHistoryDebounce: _.debounce(function(json) {
        storeHelpers.addItemToSync(this, {
          url: this.$config.get('ecApi') + "flashCards/data",
          method: "post",
          data: JSON.parse(json)
        });
      }, 5000),
      closeResource: function() {
        if (!this.canBeClosed && this.resource.category === "assessment" && storeHelpers.isSpecificAssessment(this.attachment)) {
          this.assesmentWarning = true;
        } else {
          var newRouteQuery = _.omit(this.$route.query, ['res', 'att', 'from']);
          this.$router.replace( { query: newRouteQuery } );
        }
      },
      submitAssessment: function() {
        this.wantToClose = true;
        var t = this;
        Vue.nextTick(function(){
          t.assesmentWarning = false;
          var newRouteQuery = _.omit(t.$route.query, ['res', 'att', 'from']);
          t.$router.replace( { query: newRouteQuery } );        
        });
      },
      onFlashcarddeckIframeLoad: function() {
        if (this.resource.category === "flashcarddeck") {
          this.loadFlashcarddeckDetails();
        }
      },
      loadFlashcarddeckDetails: function() {
        var t = this;
        axios.get(this.resource.absoluteUrl)
        .then(response => {
          var resourceObject = this.resource;
          resourceObject.id = resourceObject._id;
          utils.log(this, resourceObject)
          var resourceFileJson = response.data;
          var sessionHistory = storeHelpers.getFlashcardHistory(this, this.resource._id);
          if (!sessionHistory) {
            sessionHistory = { sessions: [] }
          }
          document.querySelectorAll("#flashcarddeckIframe").forEach( item => {
            item.contentWindow.Sync = {
              flashCardsTransition: function(json){
                t.postFlashCardHistoryDebounce(json);
              },
              flashCardsComplete: function(json){
                t.postFlashCardHistoryDebounce(json);
              }
            };
            item.contentWindow.flashCardPlayer.start(resourceObject, resourceFileJson, sessionHistory);
          })
        })
        .catch(function(error) {
          console.error(error);
          this.error = error;
        })
      },
      editFlashcardDeck: function() {
        this.$router.push('?edit=' + this.resource._id);
        this.closeResource();
      },
      deleteFlashcardDeck: function() {
        this.$router.push('?delete=' + this.resource._id);
        serverUtils.deleteResourceWithAttachments(this, this.resource._id);
        storeHelpers.removeResource(this, this.resource);
        this.closeResource();
      },
      closeDeletePopover: function() {
        if (this.$refs.removeFlashcardDeck) {
          this.$refs.removeFlashcardDeck.hidePopper();
        }
      }
    }
  }

</script>

<style scoped lang="scss">
@import "src/css/vars.scss";

#flashcarddeckIframe {
  width: 100%;
  height: calc(100vh - 130px);
}

audio {
  height: 54px !important;
}

.table {
  display: table;
  width: 100%;
  background: $background-color;
  margin: 0 auto !important;
  .tr {
    display: table-row;
    .td-title {
      display: table-cell;
      padding-left: 4%;
      // border: 1px solid;
    }
    .flashcard-tools {
      display: table-cell;
      text-align: right;
      padding-right: 20px;
      // border: 1px solid;
      font-size: 18pt;
      width: 15%;
    }
    .close-text {
      display: table-cell;
      width: 3%;
      font-size: 28px;
      // border: 1px solid;
    }
    .close-text:hover {
      cursor: pointer;
    }
  }
}
</style>